export const TOGGLE_CHILDREN = 'mindmap/toggleChildren';
export const ADD_CHILD = 'mindmap/addChild';
export const ADD_SIBLING = 'mindmap/addSibling';
export const MOVE_NODE = 'mindmap/moveNode';
export const CHANGE_TEXT = 'mindmap/changeText';
export const DELETE_NODE = 'mindmap/deleteNode';
export const EXPAND_ALL = 'mindmap/expandAll';
export const SET_MINDMAP = 'mindmap/setMindmap';